import React from 'react';
import type { CodeEditorHandle, CodeEditorProps } from './types';
export type { CodeEditorHandle, CodeEditorProps, CodeLanguage } from './types';

// The implementation (CodeMirror + modes + addons + CSS) is a webpack split
// point: it loads only when a CodeEditor first mounts, so pages that never show
// code pay nothing.
const Impl = React.lazy(() => import('./CodeMirrorImpl'));

export const CodeEditor = React.forwardRef<CodeEditorHandle, CodeEditorProps>(
  function CodeEditor(props, ref) {
    return (
      <React.Suspense fallback={<div className="wb-cm wb-cm--loading">loading…</div>}>
        {/* ref is passed as a normal prop so it survives React.lazy without
            depending on lazy ref-forwarding edge cases. */}
        <Impl {...props} innerRef={ref} />
      </React.Suspense>
    );
  }
);

export default CodeEditor;
